<template>
  <a-form
    id="login"
    :form="form"
    class="login-form"
    @submit="handleSubmit"
  >
    <div style="margin-bottom:20px;">
      <router-link to="/">
        <img style="width: 180px;height:60px;" src="../../assets/brand1.png">
      </router-link>
    </div>
    <a-form-item>
      <a-input
        v-decorator="[
          'username',
          { rules: [{ required: true, message: '账号不能为空!' }] },
        ]"
        placeholder="请输入账号"
      >
        <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input-password
        v-decorator="[
          'password',
          { rules: [{ required: true, message: '密码不能为空!' }] },
        ]"
        type="password"
        placeholder="请输入密码"
      >
        <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
      </a-input-password>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" html-type="submit" class="login-form-button">
        登录
      </a-button>
    </a-form-item>
    <div>仅供管理员登录，如有疑问请<router-link to="/feedback">点击此处</router-link>联系</div>
  </a-form>
</template>

<script>
import axios from 'axios';
const sha256 = require('js-sha256').sha256;

export default {
  data() {
    return {
      token: localStorage.getItem('token')
    };
  },
  mounted() {
    if (this.token !== null) {
      this.$router.replace({ path: '/admin' });
    }
  },
  beforeCreate() {
    document.title = 'Bennu\'s Blog - 登录控制台';
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.login(false);
    },
    login(forceLogin) {
      this.form.validateFields((err, values) => {
        if (!err) {
          var self = this;
          axios
            .post(self.GLOBAL.host + '/auth/login',
              JSON.stringify({ forceLogin: forceLogin, username: values.username, password: sha256(values.password) }),
              { headers: { 'Content-Type': 'application/json' } })
            .then(response => {
              var res = response.data;
              if (res.code === 1000) {
                localStorage.setItem('token', res.data.accessToken);
                this.$router.go(-1);
              } else if (res.code === 3002) {
                self.showConfirm(res.message);
              } else {
                self.$message.error(res.message);
              }
            })
            .catch(function (error) {
              self.$notification.error({
                message: '系统异常',
                description: error
              });
            });
        }
      });
    },
    showConfirm(msg) {
      var self = this;
      this.$confirm({
        title: '登录确认',
        content: msg,
        okText: '继续登录',
        cancelText: '取消',
        onOk() {
          self.login(true);
        },
        onCancel() {}
      });
    }
  }
};
</script>
<style>
#login {
  max-width: 500px;
  margin: 50px auto 0 auto;
}
#login .login-form-forgot {
  float: right;
}
#login .login-form-button {
  width: 100%;
}
</style>
